import { AfterViewInit, Component, Input } from '@angular/core';
import { WithdrawalMethod } from 'src/app/services/payment/methods/methods.models';
import { BasePageComponent } from 'src/app/components/base-page/base-page.component';
import { LicenceService } from 'src/app/services/utils/licence.service';

@Component({
  selector: 'app-withdrawal-method-selector',
  templateUrl: './withdrawal-method-selector.component.html',
  styleUrls: ['./withdrawal-method-selector.component.scss']
})
export class WithdrawalMethodSelectorComponent extends BasePageComponent implements AfterViewInit {

  public paymentList: WithdrawalMethod[];


  @Input() selectedPayment: WithdrawalMethod

  constructor(
    protected licenceService: LicenceService
  ) { super() }



  ngOnInit(): void {

  }

  ngAfterViewInit(): void {

  }



}
